import type { ProductionQuestion } from '../interfaces/ProductionQuestion.interface';

import {
	isInternalOrdersManager,
	type InternalOrdersManagerUser,
} from './isInternalOrdersManager';

type EditCheckUser = (InternalOrdersManagerUser & { id?: string | number }) | null | undefined;

type EditCheckQuestion = Pick<
	ProductionQuestion,
	'can_edit' | 'reported_by' | 'status'
> | null | undefined;

/**
 * Mirrors backend `user_can_edit_production_question`: creator or Shop Manager(s),
 * only while the question is not resolved. Prefers API `can_edit` when present.
 */
export const canEditProductionQuestion = (
	user: EditCheckUser,
	question: EditCheckQuestion,
): boolean => {
	if (!question) return false;
	if (question.status === 'resolved') return false;
	if (typeof question.can_edit === 'boolean') {
		return question.can_edit;
	}
	if (!user) return false;
	if (isInternalOrdersManager(user)) return true;
	const ownerId = question.reported_by?.id;
	if (!ownerId) return false;
	return String(ownerId) === String(user.id);
};

export default canEditProductionQuestion;
